import { Injectable, inject } from '@angular/core';
import { AgentOptions } from 'mbs-ui-shared@models/AgentOptions';
import { AgentOptionsService } from 'mbs-ui-shared@services/agent-options.service';
import { ComputersAbstractService } from 'mbs-ui-shared@services/computers.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

type EntityMap = Record<string, AgentOptions>;

@Injectable({
  providedIn: 'root'
})
export class AgentOptionsFacade {
  private service = inject(AgentOptionsService);
  private computersService = inject(ComputersAbstractService);

  private myDefault = new BehaviorSubject<AgentOptions>(null);
  public default$ = this.myDefault.asObservable();

  private myEntityMap = new BehaviorSubject<EntityMap>({});
  public entityMap$ = this.myEntityMap.asObservable();

  getDefault(): Observable<AgentOptions> {
    return this.service.getDefault().pipe(tap((option) => this.myDefault.next(option)));
  }

  getByKey(id: string): Observable<AgentOptions> {
    return this.service.getByKey(id).pipe(
      tap((entity) => {
        if (entity?.id) this.myEntityMap.next({ ...this.myEntityMap.value, [entity.id]: entity });
      })
    );
  }

  add(entity: AgentOptions): Observable<AgentOptions> {
    return this.service.add(entity).pipe(
      tap((created) => {
        if (created?.id) this.myEntityMap.next({ ...this.myEntityMap.value, [created.id]: created });
      })
    );
  }

  update(entity: AgentOptions): Observable<AgentOptions> {
    return this.service.update(entity).pipe(
      tap((updated) => {
        if (updated?.id) this.myEntityMap.next({ ...this.myEntityMap.value, [updated.id]: updated });
      })
    );
  }

  refreshMyDefault(agentOptions: AgentOptions): void {
    this.myDefault.next(agentOptions);
  }

  // deprecated from rmm16
  getGlobalAgentOptions(): Observable<any> {
    return this.service.getGlobalAgentOptions();
  }

  getGlobalAgentOptionsDeepInstinct(): Observable<any> {
    return this.service.getGlobalAgentOptionsDeepInstinct();
  }

  getComputerAgentOptions(hid: string): Observable<AgentOptions> {
    return this.computersService.getComputerAgentOptions(hid);
  }
}
